module.exports = __webpack_public_path__ + "static/media/center_logo.7d353aaf.png";